import React, { Fragment, useState } from 'react';
import { translate } from '../Services/translation';
import CartBonusCollapse from '../Components/CartBonusCollapse';
import TrackingContainer from '../Containers/Tracking.container';
import inputDelay from '../Services/inputDelay';

const Cart = ({
  onSetBonus,
  orderRows,
  orderTotal,
  authenticated,
  updateOrderRowQuantity,
  bonusImage,
  bonusToEarn,
  bonusBalance,
  acceptedBonus,
  orderCurrency,
  bonusUsed,
  bonus,
  errorMessage,
  isBusinessCustomer,
  enjoyClub,
  enjoyClubDescription,
  decimalCardValues,
}) => {
  const MIN_QUANTITY = 0;
  const MAX_QUANTITY = 999;
  const [editingQuantity, setEditingQuantity] = useState({});

  const onQuantityChange = (rowSystemId, quantity) => {
    // The quantity should be a positive number
    setEditingQuantity({
      ...editingQuantity,
      [rowSystemId]: Math.abs(quantity),
    });
  };

  const onClickPlus = (order) => {
    const quantity = order.quantity;
    if (quantity + 1 < MAX_QUANTITY) {
      handleUpdateClick(order, quantity + 1);
    }
  };

  const onClickMinus = (order) => {
    const quantity = order.quantity;
    if (quantity > MIN_QUANTITY) {
      handleUpdateClick(order, quantity - 1);
    }
  };

  const handleUpdateClick = ({ rowSystemId, quantity }, currentQuantity) => {
    const originalQuantity = editingQuantity[rowSystemId] || quantity;
    if (currentQuantity < MIN_QUANTITY || currentQuantity === originalQuantity) {
      return;
    }
    updateOrderRowQuantity(rowSystemId, currentQuantity).then(() =>
      onQuantityChange(rowSystemId, undefined)
    );
  };

  const Image = ({ order }) => (
    <div className="checkout-cart__image-wrapper">
      <img className="checkout-cart__image" src={order.image} alt={order.name} />
    </div>
  );

  const ImageInfo = ({ order }) => (
    <div className="checkout-cart__image-info">
      <a href={order.url}>{order.name}</a>
      <span className="checkout-cart__brand-name">{order.brand}</span>
    </div>
  );

  const handleUpdateClickDelayed = inputDelay(handleUpdateClick, 500);

  const OrderContent = ({ order }) => (
    <Fragment>
      <div className="align-center checkout-cart__price">
        <div className="checkout-cart__price">
          {order.campaignPrice && order.campaignPrice ? (
            <span className="checkout-cart__price__price">
              {order.campaignPrice.toUpperCase()}
            </span>
          ) : (
            <span className="checkout-cart__price__price">
              {order.price.toUpperCase()}
            </span>
          )}
          {order.price && order.campaignPrice && (
            <span className="checkout-cart__price__before-price">
              {translate('checkout.cart.price.before')}{' '}
              {order.price.toUpperCase()}
            </span>
          )}
        </div>
      </div>
      <div className="align-center">
        <div className="qtybox">
          <button
            className="qtybox__button-minus"
            onClick={(_) => onClickMinus(order)}
          >
            −
          </button>
          <input
            className="qtybox__input"
            type="number"
            min={1}
            maxLength={3}
            defaultValue={editingQuantity[order.rowSystemId] || order.quantity}
            onChange={(event) => {
              const value = event.target.value;
              if (value) {
                handleUpdateClickDelayed(order, value);
              }
            }}
          />
          <button
            className="qtybox__button-plus"
            onClick={(_) => onClickPlus(order)}
          >
            +
          </button>
        </div>
      </div>
      <div className="checkout-cart__total-price">
        {order.totalPrice && order.totalPrice.toUpperCase()}
      </div>
    </Fragment>
  );
  TrackingContainer({
    tracking: 'checkout',
    data: {
      orderRows,
    },
  });
  return (
    <Fragment>
      <div className="row no-margin checkout__container">
        <div className="row no-margin small-12 checkout-cart__table-headers-wrapper">
          <div className="row no-margin small-12 checkout-cart__table-headers">
            <div className="column-price">{translate('checkout.cart.price')}</div>
            <div className="column-qty">
              {translate('checkout.cart.quantity')}
            </div>
            <div className="column-sum">
              {translate('checkout.cart.sumprice')}
            </div>
          </div>
        </div>
        <div className="small-12 simple-table">
          {orderRows &&
            orderRows.map((order) => (
              <div className="checkout-cart__order" key={order.rowSystemId}>
                <div className="checkout-cart__row checkout-cart__row-desktop">
                  <div className="checkout-cart__image-container align-center">
                    <Image order={order} />
                    <ImageInfo order={order} />
                  </div>
                  <OrderContent order={order} />
                </div>

                <div className="checkout-cart__row checkout-cart__row-mobile">
                  <Image order={order} />
                  <div className="checkout-cart__content-wrapper-and-image-info">
                    <ImageInfo order={order} />
                    <div className="justify-between checkout-cart__content">
                      <OrderContent order={order} />
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
      {authenticated && !isBusinessCustomer && enjoyClub.isMember && (
        <div className="checkout-cart__enjoy-wrapper">
          <div className="checkout-cart__enjoy">
            <CartBonusCollapse
              {...{
                bonusToEarn,
                bonusBalance,
                bonusUsed,
                errorMessage,
                imageUrl: bonusImage,
                bonus,
                acceptedBonus,
                orderCurrency,
              }}
              onSetBonus={onSetBonus}
              text={translate('checkout.cart.link.more')}
              linkText={translate('checkout.cart.link.text')}
              enjoyClubDescription={enjoyClubDescription}
            />
          </div>
        </div>
      )}
      <div className="align-center checkout-cart__total-wrapper">
        {!decimalCardValues.discount ? (
          <div className="checkout-cart__total">
            <div className="checkout-cart__total__row">
              <div className="checkout-cart__total-title big-text">
                {translate('checkout.cart.total')}
              </div>
              <div className="text--right big-text">
                {orderTotal && orderTotal.toUpperCase()}
              </div>
            </div>
          </div>
        ) : (
          <div className="checkout-cart__total">
            <div className="checkout-cart__total__row">
              <div className="checkout-cart__total-title bold">
                {translate('checkout.cart.total-with-discount')}
              </div>
              <div className="text--right bold">
                {decimalCardValues &&
                  `${(
                    decimalCardValues.orderTotal - decimalCardValues.discount
                  ).toFixed(2)} ${orderCurrency}`.toUpperCase()}
              </div>
            </div>

            <div className="checkout-cart__total__row">
              <div className="checkout-cart__total-title">
                {translate('checkout.cart.total-without-discount')}
              </div>
              <div className="text--right strikethrough">
                {decimalCardValues &&
                  `${decimalCardValues.orderTotal.toFixed(
                    2
                  )} ${orderCurrency}`.toUpperCase()}
              </div>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default Cart;
